// extracted by mini-css-extract-plugin
export default {"text":"error-dialog-module__text___abb9b","dismissButton":"error-dialog-module__dismissButton___XW7Rt"};